import _util from '../../utils/';

const templateManagement = {
	selectTemplateManagement(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportTemplate/Get',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	deleteTemplateManagement(deletes, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportTemplate/BatchDelete',
			method: "delete",
			data: deletes,
			success: resolve,
			error: reject
		})
	},
	createTemplateManagement(posts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportTemplate/Post',
			method: "post",
			data: posts,
			success: resolve,
			error: reject
		})
	},
	updateTemplateManagement(puts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportTemplate/Put',
			method: "put",
			data: puts,
			success: resolve,
			error: reject
		})
	},
	selectTemplateManagementDetail(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportTemplate/Details',
			params: gets,
			success: resolve,
			error: reject
		})
	},
}

export default templateManagement;



// WEBPACK FOOTER //
// ./src/services/WorkReport/template-management-service.js